<template>
  <div class="Productdetail">
    <div class="wrapper-content">
      <div class="breadcrumb_box">
        <div class="container-fluid">
          <h2>Select Payment Method</h2>
        </div>
      </div>

      <div class="container productDetailsPage">
        <div class="product-right panel">
          <div class="row">
            <div class="col-md-5 col-sm-6">
              <b-form-group>
                <b-form-radio-group
                  size="lg"
                  stacked
                  v-model="selected"
                  :options="options"
                  name="radio-options"
                ></b-form-radio-group>
              </b-form-group>
              <b-button v-on:click="SubscriptionStatus">Confirm</b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { changeSubscriptionsStatus } from "./../services/api";
import moment from "moment";
import { required } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      format: "dd MMMM yyyy",
      selected: "COD",
      options: [
        { text: "Cash on Delivery", value: "COD" },
        { text: "Wallet", value: "WALLET" }
      ]
    };
  },
  created() {
    this.details = JSON.parse(localStorage.getItem("productSubscribed"));
    console.log("", this.details);
  },
  methods: {
    SubscriptionStatus() {
      var a = this.details.startdate.split("T");
      var b =
        moment(a[0], "DD-MM-YYYY", true).format("YYYY-MM-DD") +
        "T" +
        a[1] +
        "+00:00";
      var requestData = {
        address_id: this.details.user_address_id,
        area_id: this.details.addresses.area_id,
        custom_days: JSON.stringify(this.details.subscription_days),
        delivery_schedules_ids: this.details.deliverySchduleTimig[0].ds_id,
        discount_per_price_package: this.details.discount_per_price_package,
        duration_id: this.details.duration_id,
        enddate: moment(this.details.enddate).format("YYYY-MM-DD"),
        notes: this.details.notes,
        payment_mode: this.selected,
        product_id: this.details.productId,
        quantity: this.details.productQuantity,
        start_date: moment(b).format("YYYY-MM-DD"),
        status: "active",
        subscription_id: this.details.subscriptionId,
        subscription_price: this.details.subscriptionTotalPrice.toFixed(2),
        subscription_type_id: this.details.subscriptionTypeId,
        total_price: this.details.subscriptionTotalPrice,
        type: "changeSubscription",
        user_id: localStorage.getItem("userId"),
        vendor_id: localStorage.getItem("vendorId"),
        token: localStorage.getItem("token")
      };
      console.log(requestData);
      changeSubscriptionsStatus(requestData)
        .then(result => {
          console.log("subs", result);
          if (result.data.successCode === 1) {
            this.$router.push({ name: "subcription", query: { ti: 0 } });
          } else if (
            result.data.successCode === 0 &&
            result.data.messageCode === 1053
          ) {
            localStorage.clear();
            this.$router.replace({ name: "register" });
          }
        })
        .catch(error => {
          return;
        });
    }
  }
};
</script>
